import airtable from './airtable.json'

const Airtable = require('airtable')

Airtable.configure({
  endpointUrl: 'https://api.airtable.com',
  apiKey: airtable.apiKey
})

const base = Airtable.base('appMYkAI9zIfXLHJj')

const getKrishnaLines = () => {

  sessionStorage.removeItem('krishnaLines')

  return base.table('krishnaLines').select({
    sort: [{ field: "sequence", direction: "asc" }]
  }).all().then(result => {
    // sessionStorage.setItem('krishnaLines', result)
    return result
  })

}

const createComment = args => {

  let { name, comment, isPrivate, email } = args,

    isPublic = isPrivate === '1' ? false : true

  return new Promise((resolve, reject) => {

    base('comments').create([
      {
        "fields": {
          name,
          comment,
          "likes": 0,
          "dislikes": 0,
          "public": isPublic
        }
      }
    ], function (err, result) {
      if (err) {
        console.error(err)
        reject(err)
      }

      resolve(result)
    })

  })
    .then(result => {
      if (result[0].fields.public) {
        return result[0]
      }
    })
    .catch(err => {
      return err
    })

}

const getComments = () => {

  return base.table('comments').select({
    sort: [{ field: "sequence", direction: "asc" }],
    filterByFormula: "public = 1"
  }).all().then(result => result)

}

const updateComment = args => {

  return new Promise((resolve, reject) => {
    base('comments').update([
      {
        "id": args.id,
        "fields": {
          "name": args.name,
          "comment": args.comment,
          "likes": args.likes,
          "dislikes": args.dislikes
        }
      }
    ], function (err, records) {
      if (err) {
        console.error(err)
        reject(err)
        // return
      }
      // records.forEach(function (record) {
      //   console.log(record.get('name'))
      // })
      resolve('done')
    })

  })
    .then(res => res)
    .catch(err => err)

}

const sendRequestInfo = ipInfo => {

  return new Promise((resolve, reject) => {
    base('hostRequests').create([
      {
        "fields": {
          "details": JSON.stringify(ipInfo)
        }
      }
    ], function (err, records) {
      if (err) {
        console.error(err)
        reject(err)
      }
      resolve('done')
    })

  })
    .then(res => res)
    .catch(err => err)
}

const sendSbQuestionOrComment = args => {

  let { name, content, email } = args

  return new Promise((resolve, reject) => {

    base('sbQuestionsAndComments').create([
      {
        "fields": {
          "name": name,
          "commentOrQuestion": content,
          "email": email
        }
      }
    ], function (err, records) {
      if (err) {
        console.error(err)
        reject(err)
        return
      }
      // records.forEach(function (record) {
      //   console.log('response from airtable - create sb question or comment', record)
      // })
      console.log('response from airtable - create sb question or comment')
      resolve('operation-sucessfully-finished')
    })

  })
    .then(result => result )
    .catch(err =>  err )
}

const sendPost = post => {
  
  return new Promise((resolve, reject) => {
    base('posts').create([
      {
        "fields": {
          "text": post.text,
          "image": [
            {
              "url": post.image
            }
          ]
        }
      }



    ], function (err, records) {
      if (err) {
        console.error(err)
        reject(err)
      }
      resolve('done')
    })

  })
    .then(res => res)
    .catch(err => err)
}

const getPosts = () => {

  return base.table('posts').select({
    sort: [{ field: "id", direction: "asc" }]
  }).all().then(result => result )

}

export default {
  getKrishnaLines, createComment, getComments, updateComment,
  sendRequestInfo, sendSbQuestionOrComment, sendPost, getPosts
}
